import * as React from "react";
import { MapPin, Phone, Mail, Facebook, Instagram } from "lucide-react";
import { Card, CardContent } from "@/components/ui/card";
import { Link } from "@/components/common/Link";
const contactDetails = [{
  icon: MapPin,
  title: "Address",
  detail: "1008 HWY 61, Whitsett, NC 27337"
}, {
  icon: Phone,
  title: "Phone",
  detail: "(336) 684-9303"
}, {
  icon: Mail,
  title: "Email",
  detail: "info@gusenburyfields.com"
}];
const socialLinks = [{
  icon: Facebook,
  url: "#",
  label: "Visit our Facebook page"
}, {
  icon: Instagram,
  url: "#",
  label: "Visit our Instagram page"
}];
export default function ContactInformation() {
  return <section id="contact-information" className="w-full bg-background">
      {}
      <div className="relative w-full py-24 md:py-32 bg-cover bg-center bg-[url(https://wpvc-images.s3.us-east-1.amazonaws.com/images/1706703/img/lavender_contact_banner.webp)]">
        <div className="absolute inset-0 bg-background/60 backdrop-blur-sm"></div>
        <div className="relative z-10 container mx-auto px-4 text-center max-w-3xl">
          <h2 className="text-5xl md:text-6xl font-default text-foreground mb-6 lowercase tracking-tight">
            contact us
          </h2>
          <p className="text-lg md:text-xl text-foreground/80 font-default leading-relaxed">
            Let us answer any questions you may have, or let us know how we can help you.
          </p>
        </div>
      </div>

      {}
      <div className="container mx-auto px-4 py-16 md:py-24">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8 max-w-5xl mx-auto">
          {contactDetails.map((item, i) => <Card key={i} data-index={i} className="text-center border-border shadow-md hover:shadow-lg transition-shadow duration-300 bg-card">
              <CardContent className="pt-8 pb-8 flex flex-col items-center gap-5">
                <div className="p-4 bg-primary/10 rounded-xl text-primary">
                  <item.icon className="w-8 h-8" />
                </div>
                <div>
                  <h3 className="font-default text-xl font-semibold text-foreground mb-2">
                    {item.title}
                  </h3>
                  <p className="text-muted-foreground font-default">
                    {item.detail}
                  </p>
                </div>
              </CardContent>
            </Card>)}
        </div>

        {}
        <div className="mt-16 flex flex-col items-center justify-center gap-6">
          <h4 className="font-default text-lg font-medium text-foreground">
            Connect With Us
          </h4>
          <div className="flex gap-4">
            {socialLinks.map((social, i) => <Link key={i} data-index={i} to={social.url} aria-label={social.label} className="p-3 bg-secondary/10 text-secondary hover:bg-secondary hover:text-secondary-foreground rounded-xl transition-colors duration-300">
                <social.icon className="w-6 h-6" />
              </Link>)}
          </div>
        </div>
      </div>
    </section>;
}